import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isTourGuideOpen: false,
  typeOfTour: null,
  stepIndex: 0,
  searchBarExpanded: false,
  riskDatapanelExpanded: true,
  adaptationDatapanelExpanded: true,
}

const guidedTourSlice = createSlice({
  name: 'guidedTour',
  initialState,
  reducers: {
    setTourGuideState(state, action) {
      state.isTourGuideOpen = action.payload;
    },
    setTypeOfTour(state, action) {
      state.typeOfTour = action.payload;
    },
    setTourStepIndex(state, action) {
      state.stepIndex = action.payload;
    },
    setSearchBarExpanded(state, action) {
      state.searchBarExpanded = action.payload;
    },
    setRiskDatapanelExpanded(state, action) {
      state.riskDatapanelExpanded = action.payload;
    },
    setAdaptationDatapanelExpanded(state, action) {
      state.adaptationDatapanelExpanded = action.payload;
    },
  },
})

export const {
  setTourGuideState,
  setTypeOfTour,
  setTourStepIndex,
  setSearchBarExpanded,
  setRiskDatapanelExpanded,
  setAdaptationDatapanelExpanded,
} = guidedTourSlice.actions;

export default guidedTourSlice.reducer;